class RentsProfits {
    totalCurrentMonthAmount;
    totalInvestedAmount;
    totalAmount;
    rents;
    constructor(data) {
        this.totalCurrentMonthAmount = data.totalCurrentMonthAmount;
        this.totalInvestedAmount = data.totalInvestedAmount;
        this.totalAmount = data.totalAmount;
        this.rents = data.rents;
    }
}
export default RentsProfits;
